import { MainContainer } from "../../components/mainContainer";

export const Home = () => {
  return <MainContainer />;
};
